import { useCallback } from 'react'
import { useLocalDataCache } from './useLocalDataCache'

export default function useRecordsBreadcrumbs() {
  const { setBreadcrumbs: setCache, breadcrumbs } = useLocalDataCache()

  const setBreadcrumbs = useCallback(
    (crumbs) => {
      if (crumbs == null || compareBreadcrumbs(crumbs, breadcrumbs)) return
      setCache(crumbs)
    },
    [breadcrumbs, setCache]
  )

  const pushBreadcrumb = useCallback((breadcrumb) => setCache((current) => [...current, breadcrumb]), [setCache])

  return { breadcrumbs, setBreadcrumbs, pushBreadcrumb }
}

function compareBreadcrumbs(foo, bar) {
  return JSON.stringify(foo) === JSON.stringify(bar)
}
